/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_DescriptionInputs */

const en_admin_posts_description = /** @type {(inputs: Admin_Posts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage blog posts and articles`)
};

const zh_admin_posts_description = /** @type {(inputs: Admin_Posts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理博客文章`)
};

/**
* | output |
* | --- |
* | "Manage blog posts and articles" |
*
* @param {Admin_Posts_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_description = /** @type {((inputs?: Admin_Posts_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_description(inputs)
	return zh_admin_posts_description(inputs)
});
export { admin_posts_description as "admin.posts.description" }